const DEEP_LINK_INTENT_KEY = 'deepLinkIntent';

export const saveDeepLinkIntent = (architecture: string | null, planSize: string | null) => {
  if (architecture || planSize) {
    localStorage.setItem(DEEP_LINK_INTENT_KEY, JSON.stringify({ architecture, planSize }));
  }
};
